import { SET_CUSTOMER } from "../constant";

const CustomerReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_CUSTOMER:
            return {
                ...state,
                data: action.data
            }
        default:
            return state
    }
}

export default CustomerReducer;